import { ETAWidget } from "./ETAWidget.js";
import { WidgetState } from "./WidgetState.js";

const widget = new ETAWidget();
widget.mount();

if (WidgetState.isTicketDownload()) {
    await widget.loadTickets(WidgetState.getOrderNumber());
} else if (WidgetState.isRedirect()) {
    await widget.loadSession(WidgetState.getSessionId());
}
